<template>
  <v-expansion-panel
    v-if="typeof geometryData !== 'undefined' && geometryData.class === 'geometry'"
    class="dimensionsGeometry"
  >
    <v-expansion-panel-header>Dimensions</v-expansion-panel-header>
    <v-expansion-panel-content>
      <section class="item-body">
        <v-col>
          <v-row dense>
            <v-col
              v-if="hasRadius"
              cols="6"
            >
              <v-text-field
                v-model="contentGeometrRadius"
                outlined
                dense
                label="Radius (µm)"
                color="primary"
                type="number"
              />
            </v-col>
            <v-col 
              v-if="!hasRadius"
              cols="6"
            >
              <v-text-field
                v-model="contentGeometrWidth"
                outlined
                dense
                label="Width (µm)"
                color="primary"
                type="number"
              />
            </v-col>
            <v-col
              v-if="!hasRadius"
              cols="6"
            >
              <v-text-field
                v-model="contentGeometrHeight"
                outlined
                dense
                label="Height (µm)"
                color="primary"
                type="number"
              />
            </v-col>
            <v-col
              v-if="is3d && !hasRadius"
              cols="6"
            >
              <v-text-field
                v-model="contentGeometrDepth"
                outlined
                dense
                label="Depth (µm)"
                color="primary"
                type="number"
              />
            </v-col>
            <v-col v-if="!is3d" cols="12">
              <v-select
                :value="geometryData.normalization || 'device'"
                :items="normalizationRoles"
                outlined
                dense
                label="Use in spectra"
                hint="Spectra divide the power with your structure by the power in a reference run"
                persistent-hint
                @change="updateGeometry(['normalization', $event])"
              />
            </v-col>
            <!-- <v-col cols="12" v-if="geometryData.class !== 'source'">
              <v-switch
                class="mt-0 pt-0"
                color="primary"
                dense
                label="Vincular altura e largura"
                value="red"
                hide-details
              ></v-switch>
            </v-col> -->
          </v-row>
        </v-col>
      </section>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "GeometryProperties",
  mounted(){
  }, 
  props: {
    is3d: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    // Papel da geometria na normalização dos espectros (module-2d/meep/util/main.py)
    normalizationRoles: [
      { value: "device", text: "Device only (default)" },
      { value: "both", text: "Device and reference (e.g. input waveguide)" },
      { value: "reference", text: "Reference only (e.g. straight guide replacing a bend)" }
    ]
  }),
  computed: {
    ...mapGetters("simulator", ["geometryData", "dimensions"]),
    // Círculo, e no 2D também o triângulo (polígono regular), são definidos pelo raio
    hasRadius() {
      const shape = this.geometryData.shape;
      return shape === "sphere" || (!this.is3d && shape === "triangle");
    },
    contentGeometrRadius: {
      get() {
        return Number((this.geometryData.radius / (!this.is3d ? this.dimensions.relationship.x : 1)).toFixed(4));
      },
      set(value) {
        this.setCurrentGeometryRadius(Math.abs(Number(value * (!this.is3d ? this.dimensions.relationship.x : 1))));
      },
    },
    contentGeometrWidth: {
      get() {
        return Number((this.geometryData.width / (!this.is3d ? this.dimensions.relationship.x : 1)).toFixed(4));
      },
      set(value) {
        this.setCurrentGeometrySizeWidth(Number(value * (!this.is3d ? this.dimensions.relationship.x : 1)));
      },
    },
    contentGeometrHeight: { 
      get() {
        return Number((this.geometryData.height / (!this.is3d ? this.dimensions.relationship.y : 1)).toFixed(4));
      },
      set(value) {
        this.setCurrentGeometrySizeHeight(Number(value * (!this.is3d ? this.dimensions.relationship.y : 1))) ;
      },
    },
    contentGeometrDepth: {
      get() {
        return Number((this.geometryData.depth / (!this.is3d ? this.dimensions.relationship.z : 1)).toFixed(4));
      },
      set(value) {
        this.setCurrentGeometrySizeDepth(Number(value * (!this.is3d ? this.dimensions.relationship.z : 1))) ;
      }
    }
  },
  methods: {
    ...mapActions("simulator", [
      "setCurrentGeometryRadius",
      "setCurrentGeometrySizeWidth",
      "setCurrentGeometrySizeHeight",
      "setCurrentGeometrySizeDepth",
      "updateGeometry"
    ]),
  },
};
</script>